import { api } from "@/api/client";
import type { components } from "@/api/contract";
import { unwrap } from "@/api/errors";

export type ModelListResponse = components["schemas"]["ModelListResponse"];

/**
 * GET /v1/chat/models — the catalogue, for the editor's "default model" picker.
 * A thin assistant-local fn over the shared endpoint (features don't import each
 * other). It returns the full response shape so it can safely reuse the chat
 * models query key — same key, same cached shape — fetching the catalogue once.
 */
export async function listModels(): Promise<ModelListResponse> {
  return unwrap(await api.GET("/v1/chat/models", { params: { query: { limit: 100 } } }));
}
